import { Button } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { BlockCard } from 'modules/UI';

export const Container = styled.div`
  margin: 85px 0;

  ${tokens.mediaQueries.s} {
    box-sizing: content-box;
    width: 100%;
    background: ${tokens.colors.grayLight};
    margin: 0 -${tokens.space.regular} 50px;
    padding: ${tokens.space.smallest} ${tokens.space.regular};
  }
`;

export const Content = styled(BlockCard)`
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: space-around;
  justify-content: center;
  align-items: center;

  ${tokens.mediaQueries.s} {
    margin: 44px 0;
    box-sizing: border-box;
  }
`;

export const Card = styled.div`
  font-family: ${tokens.fonts.primary};
  max-width: 50%;

  ${tokens.mediaQueries.s} {
    max-width: unset;
  }
`;

export const WrapperImages = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  margin: -15px;
  align-content: space-between;
`;
export const Title = styled.h1`
  margin-bottom: ${tokens.space.regular};
  font-style: normal;
  font-weight: 300;
  font-size: ${tokens.fontSizes.xl};
  line-height: ${tokens.lineHeights.xl};
  color: ${tokens.colors.black};

  ${tokens.mediaQueries.s} {
    margin: 13px 0;
    font-size: ${tokens.fontSizes.xl};
    line-height: ${tokens.lineHeights.l};
  }
`;

export const Description = styled.p`
  font-weight: 100;
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
  max-width: 444px;
  color: ${tokens.colors.grayDarkest};
  margin: 0;

  ${tokens.mediaQueries.s} {
    font-size: ${tokens.fontSizes.l};
    line-height: ${tokens.lineHeights.l};
  }
`;

export const CardImage = styled.img`
  ${tokens.mediaQueries.s} {
    max-width: 204px;
    margin-bottom: 20px;
    margin-top: 57px;
  }
`;

export const Action = styled(Button)`
  margin-top: ${tokens.space.regular};

  ${tokens.mediaQueries.s} {
    margin-bottom: 0;
    margin-top: 30px;
    width: 100%;
  }
`;
